import { AppState } from '../AppStateProvider/interfaces';

export const complete = (state: AppState) =>
	state.brand !== null &&
	((state.market !== null && state.kvps !== null) || state.url !== null) &&
	state.password !== null &&
	state.device !== null;
